import { BrandsChannel } from 'lib/enum/brands-channel.enum';
import { PhasesSettings, privateApi } from 'services';
import { BrandsAudience, CreateBrandsAudience, UpdateBrandsAudience } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const fetchBrandsAudience = (brandsAudienceId: string): Promise<BrandsAudience> =>
    privateApi.get<BrandsAudience>(`brands-audiences/${brandsAudienceId}`);

const archiveBrandsAudience = (brandsAudienceId: string): Promise<BrandsAudience> =>
    privateApi.post<BrandsAudience>(`brands-audiences/${brandsAudienceId}/archive`);

const unarchiveBrandsAudience = (brandsAudienceId: string): Promise<BrandsAudience> =>
    privateApi.post<BrandsAudience>(`brands-audiences/${brandsAudienceId}/unarchive`);

const fetchBrandsAudiences = (businessAccountId: string, params: Record<string, unknown>): Promise<BrandsAudience[]> =>
    privateApi.get<BrandsAudience[]>(`business-accounts/${businessAccountId}/brands-audiences`, { params });

const createBrandsAudience = (brandsAudience: CreateBrandsAudience): Promise<BrandsAudience> =>
    privateApi.post<BrandsAudience>('brands-audiences', brandsAudience);

const updateBrandsAudience = (
    brandsAudienceId: string,
    brandsAudience: UpdateBrandsAudience,
): Promise<BrandsAudience> => privateApi.put<BrandsAudience>(`brands-audiences/${brandsAudienceId}`, brandsAudience);

const updateBasicBrandsAudienceChannels = (
    brandsAudienceId: string,
    channels: BrandsChannel[],
): Promise<BrandsAudience> =>
    privateApi.put<BrandsAudience>(`brands-audiences/${brandsAudienceId}/channels`, { channels });

const updateBrandsAudiencePhasesSettings = async (
    brandsAudienceId: string,
    phasesSettings: PhasesSettings,
): Promise<BrandsAudience> =>
    privateApi.put<BrandsAudience>(`brands-audiences/${brandsAudienceId}/phases-settings`, phasesSettings);

export const BrandsAudienceGateway = {
    fetchBrandsAudience,
    fetchBrandsAudiences,
    createBrandsAudience,
    updateBrandsAudience,
    updateBasicBrandsAudienceChannels,
    updateBrandsAudiencePhasesSettings,
    archiveBrandsAudience,
    unarchiveBrandsAudience,
};

const cancelableFetchBrandsAudiences = (
    businessAccountId: string,
    params?: Record<string, unknown>,
): Promise<BrandsAudience[]> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<BrandsAudience[]>(
        `business-accounts/${businessAccountId}/brands-audiences`,
        params ? { params } : null,
    );

const cancelableFetchBrandsAudience = (brandsAudienceId: string): Promise<BrandsAudience> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<BrandsAudience>(`brands-audiences/${brandsAudienceId}`);

export const CancelableBrandsAudienceGateway = {
    cancelableFetchBrandsAudiences,
    cancelableFetchBrandsAudience,
};
